import React from 'react';
import Api from '../../api/authApi';
import AppRoutes from '../../routes/routes';
import { SERVER_ERROR } from '../../constants/messages';
import { ModalAlert, ModalHeader, ModalStatusIcon, switchModal } from '../popups/modal-parts';

export default class ForgotPassword extends React.Component {
  constructor(){
    super();
    this.state = {
      success: false,
      error: false,
      loading: false
    };
  }

  handleSubmit(e){
    e.preventDefault();

    this.setState({ loading: true, error: false });

    Api.sendForgotPasswordEmail({ email: this.refs.email.value }, {
      onSuccess: ({data}) => {
        this.setState({
          success: true,
          loading: false
        });
      },
      onError: () => {
        this.setState({
          error: true,
          loading: false
        });
      }
    });
  }

  forgotPasswordForm(){
    const { error, loading } = this.state;

    return (
      <div className="modal-body">
        <ModalHeader
          title="Reset your password"
          sub="Enter the email address for your account and we'll send you a link to choose a new password."
        />
        <form className="modal-form" onSubmit={this.handleSubmit.bind(this)}>
          {error ? <ModalAlert>{SERVER_ERROR}</ModalAlert> : null}
          <div className="input-group">
            <label className="input-label" htmlFor="email">Email Address</label>
            <input
              className="input-field"
              id="email"
              type="email"
              ref="email"
              name="email"
              placeholder="doctor@hospital.com"
              autoComplete="email"
              required
            />
          </div>
          <button type="submit" className="modal-btn modal-btn-primary" disabled={loading}>
            {loading ? 'Sending link…' : 'Send reset link'}
          </button>
        </form>
        <p className="modal-footnote">
          Remembered it? <button type="button" className="modal-link" onClick={() => switchModal('login')}>Back to sign in</button>
        </p>
      </div>
    );
  }

  successMessage(){
    return (
      <div className="modal-body is-centered">
        <ModalStatusIcon type="mail" />
        <ModalHeader title="Check your inbox" />
        <div className="modal-text">
          <p>
            If there's an account for that email address, we've sent it a link to reset your password.
          </p>
        </div>
        <div className="modal-note">
          Don't forget to check your junk or spam folder if the email doesn't arrive in the next few minutes.
        </div>
        <p className="modal-footnote">
          Still haven't received it? <a href={AppRoutes.contact}>Contact us</a>
        </p>
      </div>
    );
  }

  render(){
    return this.state.success ? this.successMessage() : this.forgotPasswordForm();
  }
}
